(() => {
  if (window.__endoArticleTocLoaded) return;
  window.__endoArticleTocLoaded = true;

  const makeSlug = text =>
    text.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ł/g, 'l')
      .replace(/[^\p{L}\p{N}]+/gu, '-')
      .replace(/^-|-$/g, '') || 'sekcja';

  function buildToc(root) {
    const toc = root.querySelector('[data-article-toc]');
    const content = root.querySelector('[data-article-body]');
    const list = toc?.querySelector('ol');
    if (!toc || !content || !list) return;

    list.replaceChildren();
    toc.hidden = true;

    const usedIds = new Set(
      Array.from(document.querySelectorAll('[id]'), element => element.id)
    );

    content.querySelectorAll('h2').forEach(heading => {
      const title = heading.textContent.replace(/\s+/g, ' ').trim();
      if (!title) return;

      if (!heading.id) {
        const baseId = makeSlug(title);
        let id = baseId;
        let number = 2;

        while (usedIds.has(id)) id = `${baseId}-${number++}`;

        heading.id = id;
        usedIds.add(id);
      }

      const item = document.createElement('li');
      item.className = `article-toc__item article-toc__item--${heading.tagName.toLowerCase()}`;

      const link = document.createElement('a');
      link.className = 'article-toc__link';
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = title;

      item.appendChild(link);
      list.appendChild(item);
    });

    if (!list.children.length) return;
    toc.hidden = false;

    // Fragment w adresie może być sprawdzony, zanim zewnętrzny JS nada ID.
    if (window.location.hash) {
      try {
        const id = decodeURIComponent(window.location.hash.slice(1));
        const target = document.getElementById(id);
        if (target && content.contains(target)) {
          requestAnimationFrame(() => target.scrollIntoView());
        }
      } catch (_) {
        // Niepoprawny fragment URL nie powinien zatrzymywać spisu treści.
      }
    }
  }

  function init(scope = document) {
    if (scope.matches?.('[data-article-toc-root]')) buildToc(scope);
    scope.querySelectorAll('[data-article-toc-root]').forEach(buildToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
})();
